import { parseISO } from 'date-fns';
import { ScheduledMeetingResponse } from './useScheduledMeetings';

export const parseScheduleMeeting = (meeting: ScheduledMeetingResponse) => ({
    ...meeting,
    ...(meeting.startDate && { startDate: parseISO(meeting.startDate) }),
    ...(meeting.endDate && { endDate: parseISO(meeting.endDate) }),
    ...(meeting.times && { times: meeting.times.map(time => parseISO(time)) }),
    ...(meeting.created && { created: parseISO(meeting.created) }),
    ...(meeting.modified && { modified: parseISO(meeting.modified) }),
});
